export function sharedDefinitions(): string {
  return 'shared--definitions';
}
